import useNavigate from '@/hooks/router/useNavigate';
import { Paper, styled, Typography } from '@mui/material';
import { ApplicationForm, ClientConfigurationContext } from '@ngt/openiddict'
import { FC, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const Application: FC = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    const onCancel = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.applications ?? '/');
    }, [navigate, clientConfiguration?.administrationUris?.applications])

    const afterDelete = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.applications ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.applications]);

    const afterSubmit = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.applications ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.applications])

    return (
        <>
            <Typography variant="h1" gutterBottom>
                Application
            </Typography>
            <StyledPaper>
                <ApplicationForm
                    id={id && !isNaN(+id) ? +id : undefined}
                    afterDelete={afterDelete}
                    afterSubmit={afterSubmit}
                    onCancel={onCancel}
                    debug={import.meta.env.DEV}
                />
            </StyledPaper>
        </>
    );
}

export default Application;